<nav *ngIf="node$ | async as node">
  <ng-container *ngIf="node.children?.length">
    <div class="nav-item" *ngFor="let item of node.children">
      <h2 class="nav-item-title">{{ item.title }}</h2>

      <div class="nav-item-links" *ngIf="item.children?.length">
        <cx-generic-link
          class="nav-item-link"
          *ngFor="let subitem of item.children"
          [url]="subitem.url"
          [target]="subitem.target"
        >
          {{ subitem.title }}
        </cx-generic-link>
      </div>
    </div>
  </ng-container>
</nav>
